export default function (person) {
    if (!person.lastName) {
        return person.firstName;
    }

    if (person.attributes?.custom?.is_deceased) {
        return person.lastName.toUpperCase();
    }

    return `${person.firstName} ${person.lastName.toUpperCase()}`;
}
